import oldm from './index.mjs'

globalThis.oldm = oldm
